import React, { FC } from 'react'
import "./searchComponent.scss"
import Search from "antd/lib/input/Search";

interface SearchComponentProps {
    onSearch: Function;
}

const SearchComponent: FC<SearchComponentProps> = (props) => {
    const { onSearch } = props;

    return (
        <div className="search-component">
            <Search placeholder="Search..."
                    allowClear
                    onSearch={(searchText)=>onSearch(searchText)}
            />
        </div>
    )
}

export default SearchComponent;